// Asia/Tashkent (UTC+5) bo'yicha sana yordamchilari.
//
// Muammo: `new Date().toISOString().slice(0, 10)` har doim UTC sanasini beradi.
// Toshkent UTC+5 bo'lgani uchun mahalliy yarim tunda (00:00–05:00) UTC hali
// oldingi kunda turadi — natijada "bugun" filtri va "Bugun/Ertaga" yorlig'i
// noto'g'ri kunni ko'rsatadi. Shuning uchun mahalliy kalendar sanani Intl orqali
// Asia/Tashkent zonasida aniqlaymiz.

const TASHKENT_TZ = 'Asia/Tashkent';

/**
 * Asia/Tashkent bo'yicha joriy kalendar sana — `YYYY-MM-DD` formatida.
 * `en-CA` locale aynan `YYYY-MM-DD` ko'rinishini beradi.
 */
export function todayInTashkent(): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: TASHKENT_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

/**
 * `YYYY-MM-DD` satriga kun qo'shadi/ayiradi. UTC yarim tuniga "lang'ar" qilib
 * hisoblaymiz — shuning uchun natija timezone'dan mustaqil va to'g'ri bo'ladi.
 */
export function addDaysToDateStr(dateStr: string, days: number): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + days);
  return dt.toISOString().slice(0, 10);
}
